import { useUserDetailProfileBankAccount } from './hooks';
import { convertToPresentationProps } from './logics';
import { UserDetailProfileBankAccountPresentation } from './presentations';

type Props = {
  /** 利用者ID */
  userId: number;
};

/**
 * 利用者詳細プロフィール（BankAccount）Container
 *
 * - API から利用者情報を取得してプロフィールとして表示する
 * - カスタムフィールドはプロフィール API の custom_field_values をそのまま使って表示する
 * - 親コンポーネント（Screen）で Suspense にラップすること
 */
export const UserDetailProfileBankAccount: React.FC<Props> = ({ userId }) => {
  const {
    state: { data, profileData, bankAccountData },
  } = useUserDetailProfileBankAccount(userId);

  const {
    fullName,
    email,
    clientName,
    branchCode,
    accountNumber,
    linkedAtLabel,
    billableFromLabel,
    createdAtLabel,
    updatedAtLabel,
    editLink,
    customFields,
  } = convertToPresentationProps({
    data,
    userId,
    profileData,
    bankAccountData,
  });

  return (
    <UserDetailProfileBankAccountPresentation
      fullName={fullName}
      email={email}
      clientName={clientName}
      branchCode={branchCode}
      accountNumber={accountNumber}
      linkedAtLabel={linkedAtLabel}
      billableFromLabel={billableFromLabel}
      createdAtLabel={createdAtLabel}
      updatedAtLabel={updatedAtLabel}
      editLink={editLink}
      customFields={customFields}
    />
  );
};
